import { AnyObject, CardStructureConfig, ItemAttrListDataSet } from '@mri/types';

export function cardGetImgRender(prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): string | undefined {
  if (typeof structure.img === 'function')
    return structure.img(prop);

  return undefined;

}